<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="footer">
    <!-- Top accent line -->
    <div class="footer__accent" aria-hidden="true"></div>

    <!-- Main content -->
    <div class="footer__main">
      <div class="footer__container">
        <div class="row q-col-gutter-xl">
          <!-- Brand column -->
          <div class="col-12 col-md-4">
            <div class="footer__logo" @click="navigate('/')">
              <img src="../assets/GKPNGv1.png" alt="Golden Key" />
            </div>
            <p class="footer__tagline">
              Seu portal de confiança. Encontre o imóvel dos seus sonhos com as
              melhores condições do mercado.
            </p>
            <div class="footer__socials">
              <button
                class="social-btn"
                @click="openSocial('facebook')"
                aria-label="Facebook"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="16"
                  height="16"
                >
                  <path
                    d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                  />
                </svg>
              </button>
              <button
                class="social-btn"
                @click="openSocial('instagram')"
                aria-label="Instagram"
              >
                <svg
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  width="16"
                  height="16"
                >
                  <path
                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
                  />
                </svg>
              </button>
              <button
                class="social-btn"
                @click="openSocial('linkedin')"
                aria-label="LinkedIn"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="16"
                  height="16"
                >
                  <path
                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="col-12 col-sm-6 col-md-2">
            <div class="footer__col-label">Links Rápidos</div>
            <nav class="footer__links">
              <span
                v-for="link in quickLinks"
                :key="link.label"
                class="footer__link"
                @click="navigate(link.route)"
              >
                {{ link.label }}
              </span>
            </nav>
          </div>

          <!-- Imóveis -->
          <div class="col-12 col-sm-6 col-md-2">
            <div class="footer__col-label">Imóveis</div>
            <nav class="footer__links">
              <span
                v-for="item in imoveisLinks"
                :key="item.label"
                class="footer__link"
                @click="navigate(item.route)"
              >
                {{ item.label }}
              </span>
            </nav>
          </div>

          <!-- Contact -->
          <!-- Contact -->
          <div class="col-12 col-md-3">
            <div class="footer__col-label">Contacto</div>
            <div class="footer__contact">
              <a href="tel:+258827016716" class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.08 6.08l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                </span>
                +258 82 701 6716
              </a>
              <a href="mailto:comercial@goldenkey.co.mz" class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                comercial@goldenkey.co.mz
              </a>
              <div class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </span>
                <span>Seg – Sex: 8h às 18h &nbsp;·&nbsp; Sáb: 9h às 14h</span>
              </div>
            </div>

            <div class="footer__col-label" id="emergence_contact">
              Contactos de Emergência
            </div>
            <div class="footer__contact">
              <a href="tel:21322334" class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.08 6.08l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                </span>
                21322334 - Bombeiros
              </a>
              <a href="tel:198" class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.08 6.08l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                </span>
                119 - PRM
              </a>
              <a href="tel:117" class="contact-row">
                <span class="contact-row__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    width="15"
                    height="15"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.08 6.08l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
                    />
                  </svg>
                </span>
                117 - Emergência médica
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="footer__bottom">
      <div class="footer__container footer__bottom-inner">
        <span class="footer__copy">
          © {{ currentYear }} Golden Key &nbsp;·&nbsp; Um produto da
          <a
            href="https://marrar.co.mz"
            target="_blank"
            rel="noopener"
            class="footer__marrar"
            >Marrar, LDA</a
          >
          &nbsp;em parceria com a
          <a
            href="https://www.grabimobiliaria.com/"
            target="_blank"
            rel="noopener"
            class="footer__marrar"
            >Grab Imobiliária</a
          >
          e <span class="footer__marrar"> INTELEMOBILIARIA.</span>
        </span>
        <div class="footer__legal">
          <a
            href="#"
            class="footer__legal-link"
            @click.prevent="navigate('/privacidade')"
            >Política de Privacidade</a
          >
          <a
            href="#"
            class="footer__legal-link"
            @click.prevent="navigate('/termos')"
            >Termos de Uso</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from "vue";
import router from "@/router";

const currentYear = computed(() => new Date().getFullYear());

const quickLinks = [
  { label: "Início", route: "/" },
  { label: "Sobre Nós", route: "/sobre" },
  { label: "Contacto", route: "/contato" },
  { label: "Suporte", route: "/suporte" },
];

const imoveisLinks = [
  { label: "Comprar", route: "/imoveis/comprar" },
  { label: "Arrendar", route: "/imoveis/arrendamento" },
  { label: "Anunciar Imóvel", route: "https://portal.goldenkey.co.mz" },
];

const navigate = (route) => {
  if (route.startsWith("http")) {
    window.open(route, "_blank");
    return;
  }
  router.push(route);
};

const openSocial = (platform) => {
  const urls = {
    facebook: "https://www.facebook.com/share/1HEBf8KKtB/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/goldenkey.app?igsh=MTk2OWh5M3o0Ym1ubg%3D%3D&utm_source=qrk",
    linkedin: "https://www.linkedin.com/company/golden-key-app/",
  };
  if (urls[platform]) window.open(urls[platform], "_blank");
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap");

/* ══════════════════════════════════════════════════
   Shell
══════════════════════════════════════════════════ */
.footer {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif;
  background: #0a1628;
  margin-top: auto;
}

.footer__container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* ── Top accent ─────────────────────────────── */
.footer__accent {
  height: 1px;
  background: linear-gradient(
    to right,
    transparent 0%,
    rgba(235, 163, 1, 0.35) 20%,
    rgba(235, 163, 1, 0.35) 80%,
    transparent 100%
  );
}

/* ══════════════════════════════════════════════════
   Main content
══════════════════════════════════════════════════ */
.footer__main {
  padding: 4.5rem 0 3.5rem;
}

/* ── Brand column ───────────────────────────── */
.footer__logo {
  display: inline-block;
  cursor: pointer;
  margin-bottom: 1.25rem;
  opacity: 0.92;
  transition: opacity 0.2s ease;
}

.footer__logo:hover {
  opacity: 1;
}

.footer__logo img {
  height: 72px;
  width: auto;
  display: block;
  filter: brightness(1.05);
}

.footer__tagline {
  font-size: 0.845rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.75;
  margin: 0 0 1.75rem;
  max-width: 300px;
}

/* ── Social icons ───────────────────────────── */
.footer__socials {
  display: flex;
  gap: 10px;
}

.social-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.22s ease, border-color 0.22s ease, color 0.22s ease;
  padding: 0;
}

.social-btn:hover {
  background: rgba(235, 163, 1, 0.12);
  border-color: rgba(235, 163, 1, 0.4);
  color: #eba301;
}

/* ── Column headings ────────────────────────── */
.footer__col-label {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #eba301;
  margin-bottom: 1.25rem;
}

/* ── Nav links ──────────────────────────────── */
.footer__links {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer__link {
  font-size: 0.855rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.42);
  cursor: pointer;
  padding: 0.3rem 0;
  display: inline-block;
  transition: color 0.2s ease, transform 0.2s ease;
}

.footer__link:hover {
  color: rgba(255, 255, 255, 0.9);
  transform: translateX(4px);
}

/* ── Contact ────────────────────────────────── */
.footer__contact {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.contact-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.845rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.42);
  text-decoration: none;
  transition: color 0.2s ease;
  line-height: 1.5;
}

a.contact-row:hover {
  color: rgba(255, 255, 255, 0.85);
}

.contact-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.35);
}

a.contact-row:hover .contact-row__icon {
  background: rgba(235, 163, 1, 0.1);
  color: #eba301;
}

/* ══════════════════════════════════════════════════
   Bottom bar
══════════════════════════════════════════════════ */
.footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 1.25rem 0;
}

.footer__bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.footer__copy {
  font-size: 0.77rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.28);
}

.footer__marrar {
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer__marrar:hover {
  color: rgba(255, 255, 255, 0.8);
}

.footer__legal {
  display: flex;
  gap: 1.5rem;
}

.footer__legal-link {
  font-size: 0.77rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.28);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer__legal-link:hover {
  color: rgba(255, 255, 255, 0.7);
}

#emergence_contact {
  padding-top: 40px;
}

/* ── Responsive ─────────────────────────────── */
@media (max-width: 768px) {
  .footer__main {
    padding: 3rem 0 2.5rem;
  }

  .footer__tagline {
    max-width: 100%;
  }

  .footer__bottom-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  #emergence_contact {
    padding-top: 60px;
  }
}
</style>
